import React, { useRef } from 'react';
import { gsap } from 'gsap';
import { useGSAP } from '@gsap/react';
import JobCard from './JobCard';
import { JobResult } from '../types/job';

interface JobCardListProps {
  results: JobResult[];
}

const JobCardList: React.FC<JobCardListProps> = ({ results }) => {
  const container = useRef<HTMLDivElement>(null);

  useGSAP(() => {
    gsap.from('.job-card', {
      duration: 0.8,
      y: 100,
      opacity: 0,
      delay: 0.1,
      stagger: 0.2,
      ease: 'power2.inOut',
    });
  }, { scope: container });

  return (
    <div ref={container} className="job-card-list">
      {results.map((result, index) => (
        <JobCard key={index} result={result} />
      ))}
    </div>
  );
};

export default JobCardList;
